// Iter 110y — Central feature flags surfaced to the React app via CRA env.
// Each flag reads its `REACT_APP_*` variable at build time and defaults to
// its safest state. When flipping a flag, run `yarn build` (or restart the
// dev server) so the compiled bundle picks up the new value.
//
// Currently gated:
//   - GCHAT_ENABLED: hides Chat nav, /chat route, mentions feed, chat
//     unread badges. Backend also gates via GCHAT_ENABLED — keep the two
//     env vars in lock-step.

export const GCHAT_ENABLED =
  (process.env.REACT_APP_GCHAT_ENABLED || "false").toLowerCase() === "true";
